import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	BORDER_WIDTH_VALUES,
	CORNER_RADIUS_VALUES,
	FONT_SIZE_VALUES,
	LINE_HEIGHT_VALUES,
	SPACING_VALUES,
	type PresetOption,
} from '@dealstack/frontend/shared/components/EmailTemplates/utils/inspectorPresets';

import type { InspectorPresets } from './useInspectorPresets.types';

export const useInspectorPresets = (): InspectorPresets => {
	const tMipManage = useTranslationMipManage();

	const option = (value: string, key: string, defaultValue: string): PresetOption => ({
		value,
		label: tMipManage(`email_templates.editor.presets.${key}`, { defaultValue }),
	});

	return {
		fontSize: [
			option(FONT_SIZE_VALUES[0], 'small', 'Small'),
			option(FONT_SIZE_VALUES[1], 'medium', 'Medium'),
			option(FONT_SIZE_VALUES[2], 'large', 'Large'),
		],
		lineHeight: [
			option(LINE_HEIGHT_VALUES[0], 'tight', 'Tight'),
			option(LINE_HEIGHT_VALUES[1], 'normal', 'Normal'),
			option(LINE_HEIGHT_VALUES[2], 'relaxed', 'Relaxed'),
		],
		spacing: [
			option(SPACING_VALUES[0], 'none', 'None'),
			option(SPACING_VALUES[1], 'small', 'Small'),
			option(SPACING_VALUES[2], 'medium', 'Medium'),
			option(SPACING_VALUES[3], 'large', 'Large'),
		],
		borderWidth: [
			option(BORDER_WIDTH_VALUES[0], 'none', 'None'),
			option(BORDER_WIDTH_VALUES[1], 'thin', 'Thin'),
			option(BORDER_WIDTH_VALUES[2], 'medium', 'Medium'),
			option(BORDER_WIDTH_VALUES[3], 'thick', 'Thick'),
		],
		cornerRadius: [
			option(CORNER_RADIUS_VALUES[0], 'square', 'Square'),
			option(CORNER_RADIUS_VALUES[1], 'small', 'Small'),
			option(CORNER_RADIUS_VALUES[2], 'medium', 'Medium'),
			option(CORNER_RADIUS_VALUES[3], 'large', 'Large'),
		],
	};
};
